import { createContext } from 'react';

export type TCommentsContext = {
  userId?: string;
  userPublicAddress?: string;
  articleId: string;
  loadingAuthenticatedUserStatus: boolean;
};

export const CommentsContext = createContext<TCommentsContext>({} as TCommentsContext);
